"use client"

import clsx from "clsx"
import { ReactNode } from "react"
import { A } from "src/components/generic/A"
import { useEventCallback } from "src/components/hooks/useEventCallback"
import { posthogCapture } from "src/integrations/posthog/events"

export type HeaderTextLinkProps = {
  href: string | null | undefined
  mobile?: boolean
  children: ReactNode
}

export const HeaderTextLink = ({ href, mobile, children }: HeaderTextLinkProps) => {
  const Element = href ? A : "div"

  const onClick = useEventCallback(() =>
    posthogCapture("header_link_clicked", {
      href: href || null,
      text: typeof children === "string" ? children : "other",
    }),
  )

  return (
    <Element
      href={href || undefined}
      onClick={onClick}
      className={clsx("group relative flex min-h-12 items-center gap-2 px-4 font-normal whitespace-nowrap", {
        "hover:text-np-green transition-colors hover:bg-gray-100 hover:transition-none": href,
        "rounded-full": !mobile,
        "border-t": mobile,
      })}
    >
      {children}
    </Element>
  )
}
